<div class="main-view-container-loader">
  <img [src]="'assets/icons/loading.svg'">
  <div style="margin-left: 8px;">Loading...</div>
</div>